/** Workspace RBAC — enabled by default (CTO EO-002). Set VITE_TASALLOT_WORKSPACE_ROUTING=0 to disable. */
export function isWorkspaceRoutingEnabled(): boolean {
  try {
    if (import.meta.env.VITE_TASALLOT_WORKSPACE_ROUTING === '0') return false;
    if (localStorage.getItem('TASALLOT_WORKSPACE_ROUTING') === '0') return false;
  } catch {
    /* ignore */
  }
  return true;
}

export const WORKSPACE_STORAGE_KEY = 'tasallot_admin_workspace';
export const ASSIGNED_WORKSPACES_KEY = 'tasallot_assigned_workspaces';
